<template>
  <div class="table-responsive">
    <vs-button icon danger class="ml-auto" style="width: fit-content" @click="toPdf()"> <i class="fa-solid fa-file-circle-plus mr-2"></i> Generar PDF </vs-button>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="false"
      filename="desprendible"
      :pdf-quality="2"
      pdf-format="letter"
      pdf-orientation="landscape"
      pdf-content-width="1000px"
      :html-to-pdf-options="HtmlOpciones"
      style="margin: 0 !important; padding: 0 !important"
    >
      <table class="table table-sm">
        <thead>
          <tr>
            <th v-for="(col, i) in columnas" :key="'col-' + i">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(fila, index) in filas"
            :key="'fila-' + index"
            :class="[esFilaEspecial(fila.operacion) ? 'resumen-final' : '', index > 0 && esMismaAgrupacion(fila, filas[index - 1]) ? 'sin-borde-superior' : '']"
          >
            <td>{{ fila.operacion }}</td>
            <td>{{ fila.valores }}</td>
            <!-- <td>{{ fila.valores2 }}</td> -->
          </tr>
        </tbody>
      </table>
    </vue-html2pdf>
    <table class="table table-sm">
      <thead>
        <tr>
          <th v-for="(col, i) in columnas" :key="'col-' + i">{{ col }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(fila, index) in filas"
          :key="'fila-' + index"
          :class="[esFilaEspecial(fila.operacion) ? 'resumen-final' : '', index > 0 && esMismaAgrupacion(fila, filas[index - 1]) ? 'sin-borde-superior' : '']"
        >
          <td>{{ fila.operacion }}</td>
          <td style="text-align: end">{{ fila.valores }}</td>
          <!-- <td>{{ fila.valores2 }}</td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
export default {
  components: {
    VueHtml2pdf,
  },
  props: ["name", "data", "dataGeneral"],
  name: "registroServicios",
  data() {
    return {
      // columnas: ["Operación", "Sin Aporte Vol.", "Con Aporte Vol."],
      columnas: ["Operación", "Valor"],
      filas: [
        {
          grupo: 1,
          operacion: "Total Devengos",
          valores: this.data.valorAFacturar.toLocaleString("es-CO", { style: "currency", currency: "COP" }),
          valores2: this.data.valorAFacturar.toLocaleString("es-CO", { style: "currency", currency: "COP" }),
        },
        // { grupo: 1, operacion: "Descuentos en la base", valores: "1", valores2: "2" },
        // { grupo: 1, operacion: "Aporte Salud Obligatorio", valores: "1", valores2: "2" },
        // { grupo: 1, operacion: "Aporte Pensión y Fondo de solidaridad", valores: "1", valores2: "2" },
        // { grupo: 1, operacion: "Aporte Voluntario a Fondo Obligatorio", valores: "1", valores2: "2" },
        // { grupo: 2, operacion: "Base despues de Deducciones art 387", valores: "1", valores2: "2" },
        // { grupo: 3, operacion: "Intereses sobre préstamos de vivienda", valores: "1", valores2: "2" },
        // { grupo: 3, operacion: "Salud Prepagada (máximo 16 UVT)", valores: "1", valores2: "2" },
        // { grupo: 3, operacion: "Deducción por personas a cargo (10% Devengos)", valores: "1", valores2: "2" },
        // { grupo: 4, operacion: "Total deducciones", valores: "1", valores2: "2" },
        // { grupo: 5, operacion: "Aporte Voluntario a Fondo Alterno", valores: "1", valores2: "2" },
        // { grupo: 5, operacion: "Total Rentas Exentas (max 30% o 3800 UVT anual)", valores: "1", valores2: "2" },
        // { grupo: 6, operacion: "25% Exento (max 790 UVT anual)", valores: "1", valores2: "2" },
        // { grupo: 6, operacion: "Total deducciones (max 40% o 1340 UVT anual incluido 25% exento)", valores: "1", valores2: "2" },
        // { grupo: 7, operacion: "Base después de deducciones", valores: "1", valores2: "2" },
        // { grupo: 7, operacion: "Valor UVT", valores: "1", valores2: "2" },
        // { grupo: 8, operacion: "Base en UVT", valores: "1", valores2: "2" },
        // { grupo: 8, operacion: "Intervalo Inicial", valores: "1", valores2: "2" },
        // { grupo: 9, operacion: "Base 1", valores: "1", valores2: "2" },
        // { grupo: 9, operacion: "Porcentaje según tabla", valores: "1", valores2: "2" },
        // { grupo: 10, operacion: "Base 2", valores: "1", valores2: "2" },
        // { grupo: 10, operacion: "UVT Adicional", valores: "1", valores2: "2" },
        // { grupo: 11, operacion: "Retención en UVT", valores: "1", valores2: "2" },
        // { grupo: 11, operacion: "Valor UVT", valores: "1", valores2: "2" },
        // { grupo: 12, operacion: "Retención Total", valores: "1", valores2: "2" },
        // { grupo: 12, operacion: "Retención quincena anterior", valores: "1", valores2: "2" },
        // { grupo: 13, operacion: "Retención a Favor", valores: "1", valores2: "2" },
        // { grupo: 13, operacion: "Valor a retener", valores: "1", valores2: "2" },
        // { grupo: 13, operacion: "Retención Contingente", valores: "1", valores2: "2" },
        { grupo: 1, operacion: "Gastos financieros", valores: this.data.gastosFinancieros.toLocaleString("es-CO", { style: "currency", currency: "COP" }), valores2: 6000 },
        {
          grupo: 1,
          operacion: "Retención en la fuente (" + this.dataGeneral.retencionEnLaFuenteArt + ")",
          valores: this.data.retencionEnLaFuente.toLocaleString("es-CO", { style: "currency", currency: "COP" }),
          valores2: "2",
        },
        { grupo: 1, operacion: "Total ICA", valores: this.data.ica.toLocaleString("es-CO", { style: "currency", currency: "COP" }), valores2: "2" },
        { grupo: 1, operacion: "Otras deducciones", valores: this.data.otrasDeducciones.toLocaleString("es-CO", { style: "currency", currency: "COP" }), valores2: "2" },
        { grupo: 2, operacion: "Descuento de garantías", valores: this.data.garantias.toLocaleString("es-CO", { style: "currency", currency: "COP" }), valores2: "2" },

        { grupo: 3, operacion: "Total deducciones", valores: this.data.totalDeducciones.toLocaleString("es-CO", { style: "currency", currency: "COP" }), valores2: "2" },
        { grupo: 3, operacion: "Total a pagar", valores: this.data.totalAPagar.toLocaleString("es-CO", { style: "currency", currency: "COP" }), valores2: "2" },
        // { grupo: 3, operacion: "Deducción por personas a cargo (10% Devengos)", valores: "1", valores2: "2" },
        // { grupo: 4, operacion: "Total deducciones", valores: "1", valores2: "2" },
        // { grupo: 5, operacion: "Aporte Voluntario a Fondo Alterno", valores: "1", valores2: "2" },
        // { grupo: 5, operacion: "Total Rentas Exentas (max 30% o 3800 UVT anual)", valores: "1", valores2: "2" },
        // { grupo: 6, operacion: "25% Exento (max 790 UVT anual)", valores: "1", valores2: "2" },
        // { grupo: 6, operacion: "Total deducciones (max 40% o 1340 UVT anual incluido 25% exento)", valores: "1", valores2: "2" },
        // { grupo: 7, operacion: "Base después de deducciones", valores: "1", valores2: "2" },
        // { grupo: 7, operacion: "Valor UVT", valores: "1", valores2: "2" },
        // { grupo: 8, operacion: "Base en UVT", valores: "1", valores2: "2" },
        // { grupo: 8, operacion: "Intervalo Inicial", valores: "1", valores2: "2" },
        // { grupo: 9, operacion: "Base 1", valores: "1", valores2: "2" },
        // { grupo: 9, operacion: "Porcentaje según tabla", valores: "1", valores2: "2" },
        // { grupo: 10, operacion: "Base 2", valores: "1", valores2: "2" },
        // { grupo: 10, operacion: "UVT Adicional", valores: "1", valores2: "2" },
        // { grupo: 11, operacion: "Retención en UVT", valores: "1", valores2: "2" },
        // { grupo: 11, operacion: "Valor UVT", valores: "1", valores2: "2" },
        // { grupo: 12, operacion: "Retención Total", valores: "1", valores2: "2" },
        // { grupo: 12, operacion: "Retención quincena anterior", valores: "1", valores2: "2" },
        // { grupo: 13, operacion: "Retención a Favor", valores: "1", valores2: "2" },
        // { grupo: 13, operacion: "Valor a retener", valores: "1", valores2: "2" },
        // { grupo: 13, operacion: "Retención Contingente", valores: "1", valores2: "2" },
      ],
    };
  },
  methods: {
    toPdf() {
      //html2pdf(document.getElementById('exportpdf'));
      //this.$refs.html2Pdf.generatePdf();
      this.$refs.html2Pdf.generatePdf();
    },
    esFilaEspecial(operacion) {
      const claves = ["Retención Total", "Retención quincena anterior", "Retención a Favor", "Valor a retener", "Retención Contingente"];
      return claves.includes(operacion);
    },
    esMismaAgrupacion(actual, anterior) {
      return actual.grupo === anterior.grupo;
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  font-size: 13px;
  vertical-align: middle;
}

/* Estilo de resumen final */
.resumen-final {
  font-weight: bold;
  background-color: var(--dark-bg);
}

/* Estilo para quitar la línea superior si es del mismo grupo */
.sin-borde-superior td {
  border-top: none !important;
}
</style>
